module.exports = __webpack_public_path__ + "img/sales.9f9735d5.svg";